function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "la_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fillOpacity: 0.7,
  d: "M0 0h640v480H0z"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  clipPath: "url(#la_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ce1126",
  d: "M-40 0h720v480H-40z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#002868",
  d: "M-40 119.3h720v241.4H-40z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M423.4 240a103.4 103.4 0 11-206.8 0 103.4 103.4 0 11206.8 0z"
}));

var SvgLa = function SvgLa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 640 480"
  }, props), _ref, _ref2);
};

export default SvgLa;